/**
 * View component for /admin/authoring/courses/new
 *
 * Creates a new course from a copy of the defaultItem in the course reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { history, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as courseActions from '../courseActions';
import * as sponsorActions from '../../sponsor/sponsorActions';
import * as studyActions from '../../study/studyActions';
import * as contentModuleActions from '../../contentModule/contentModuleActions';

// import global components
import TrainingManagementLayout from '../../admin/components/TrainingManagementLayout.js.jsx';
import Base from "../../../global/components/BaseComponent.js.jsx";
import Breadcrumbs from '../../../global/components/routing/Breadcrumbs.js.jsx';

// import course components
import CourseForm from '../components/CourseForm.js.jsx';

class AdminCreateCourse extends Base {
  constructor(props) {
    super(props);
    this.state = {
      course: { ...this.props.defaultCourse }
      // NOTE: We don't want to actually change the store's defaultItem, just use a copy
      , formHelpers: {
        isNewOverviewContent: true
        , statuses: ['published', 'draft', 'archived']
      }
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(sponsorActions.fetchListIfNeeded());
    dispatch(contentModuleActions.fetchListIfNeeded("_organization", null, "_group", null, "published", true));

  }

  _handleFormChange(e) {
    /**
     * This let's us change arbitrarily nested objects with one pass
     */
    let newState = _.update( this.state, e.target.name, function() {
      return e.target.value;
    });
    // NOTE: only do this on the create form
    if(e.target.name === "course.title") {
      newState.course.slug = _.kebabCase(e.target.value);
    }
    this.setState(newState);
    // funcationality when selecting allSponsors and studies
    const { dispatch } = this.props;
    const { course } = this.state;

    if(e.target.name === 'course._organization') {
      dispatch(studyActions.fetchListIfNeeded("_organization", e.target.value));
      dispatch(contentModuleActions.fetchListIfNeeded("_organization", e.target.value, "_group", null, "published", true));
      // clear study so the form doesn't show non needed values
      course._group = null;
      course._contentModules = [];
      this.setState({
        course
      });
    }
    if(e.target.name === 'course._group') {
      dispatch(contentModuleActions.fetchListIfNeeded("_group", e.target.value, "published", true));
    }
  }


  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(courseActions.sendCreateCourse(this.state.course)).then((action) => {
      if(action.success) {
        dispatch(courseActions.invalidateList());
        history.push(`/admin/content-management/courses/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert(`ERROR: ${action.error}`);
      }
    });
  }

  render() {
    const { course, formHelpers } = this.state;
    const {
      sponsorStore
      , studyStore
      , contentModuleStore
    } = this.props;
    const isEmpty = (course.title === null || course.title === undefined);
    const allSponsors = sponsorStore.util.getList() || [];
    const allStudies = studyStore.util.getList("_organization", course._organization) || [];
    let contentModules = [];
    // get all needed content modules
    const universalContentModules = contentModuleStore.util.getList("_organization", null, "_group", null, "published", true) || [];
    const sponsorContentModules = contentModuleStore.util.getList("_organization", course._organization, "_group", null, "published", true) || [];
    const studyContentModules = contentModuleStore.util.getList("_group", course._group, "published", true) || [];
    // combine all arrays & drop duplicates
    contentModules = _.unionBy(universalContentModules, sponsorContentModules, studyContentModules, "_id");
    return (
      <TrainingManagementLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <Breadcrumbs links={location.state.breadcrumbs} />
            </div>
            { isEmpty ?
              <h2> Loading...</h2>
              :
              <CourseForm
                allSponsors={allSponsors}
                allStudies={allStudies}
                cancelLink="/admin/content-management/courses"
                course={course}
                formHelpers={formHelpers}
                formTitle="Create Course"
                formType="create"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
                contentModules={contentModules}
                />
            }
          </section>
        </div>
      </TrainingManagementLayout>
    )
  }
}

AdminCreateCourse.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    defaultCourse: store.course.defaultItem
    , sponsorStore: store.sponsor
    , studyStore: store.study
    , contentModuleStore: store.contentModule
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AdminCreateCourse)
);



// WEBPACK FOOTER //
// modules/course/views/AdminCreateCourse.js.jsx